import { ISmevMonitoringIndex } from 'APIPackage/SmevMonitoringModule/interfaces/ISmevMonitoringIndex';
import { formatDate } from 'CorePackage/MainModule/common/formatDate';
import { DATE_FORMAT_FULL_FNS } from 'CorePackage/MainModule/constants/dateFormats';

export const mapDataToSmevMonitoringRow = (data: ISmevMonitoringIndex[]): ISmevMonitoringIndex[] => {
  return data.map(row => ({
    ...row,
    knmErpId: row.knmErpId?.replaceAll(',', ', '),
    receiveCreatedAt: row?.receiveCreatedAt
      ? formatDate({
          date: row.receiveCreatedAt,
          dateFormat: DATE_FORMAT_FULL_FNS,
        })
      : '',
    sendCreatedAt: row.sendCreatedAt ? formatDate({ date: row.sendCreatedAt, dateFormat: DATE_FORMAT_FULL_FNS }) : '',
    smevCreatedAt: row.smevCreatedAt ? formatDate({ date: row.smevCreatedAt, dateFormat: DATE_FORMAT_FULL_FNS }) : '',
  }));
};
